<template>
  <div>
    <v-dialog
        v-model="dialog"
        width="50%"
        hide-overlay
        outline
    >
        <template
          v-slot:activator="{ on }"
          v-if="!review.published"
        >
            <v-btn
                data-testid="toggle-reviews-display-btn"
                class="toggle-reviews-display-btn ml-0"
                v-on="on"
                small
                color="grey"
            >
                Display
            </v-btn>
        </template>
        <template
          v-slot:activator="{ on }"
          v-else
        >
            <v-btn
                data-testid="toggle-reviews-hide-btn"
                class="toggle-reviews-hide-btn ml-0"
                v-on="on"
                small
                color="success"
            >
                Hide
            </v-btn>
        </template>

        <v-card v-if="!review.published">
            <v-card-title
              class="headline"
              primary-title
            >
              Display Review
            </v-card-title>
            <v-divider />
            <v-container>
                Do you want to display this review on this facility page?
            </v-container>
            <v-divider />
            <v-card-actions>
                <v-btn
                    data-testid="toggle-reviews-cancel-btn"
                    class="toggle-reviews-cancel-btn"
                    color="error"
                    @click="dialog = false"
                >
                    Cancel
                </v-btn>
                <v-spacer />
                <v-btn
                    data-testid="toggle-reviews-display-btn"
                    class="toggle-reviews-display-btn"
                    color="primary"
                    type="submit"
                    :loading="loading"
                    :disabled="loading"
                    @click="displayReview(review.id, review)"
                >
                  Display
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card v-else>
            <v-card-title
              class="headline"
              primary-title
            >
              Hide Review
            </v-card-title>
            <v-divider />
            <v-container>
                Do you want to hide this review from this facility page?
            </v-container>
            <v-divider />
            <v-card-actions>
                <v-btn
                    data-testid="toggle-reviews-hide-cancel-btn"
                    class="toggle-reviews-hide-cancel-btn"
                    color="error"
                    @click="dialog = false"
                >
                    Cancel
                </v-btn>
                <v-spacer />
                <v-btn
                    data-testid="toggle-reviews-hide-review-btn"
                    class="toggle-reviews-hide-review-btn"
                    color="primary"
                    type="submit"
                    :loading="loading"
                    :disabled="loading"
                    @click="hideReview(review.id, review)"
                >
                  Hide
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    review: {
      type: Object
    }
  },

  data() {
    return {
      dialog: false,
      loading: false
    };
  },

  methods: {
    displayReview(id, review) {
      this.$store.dispatch("publishReview", review)
        .then(() => {
          this.dialog = false;
        });
    },
    hideReview(id, review) {
      this.$store.dispatch("removeReview", review)
        .then(() => {
          this.dialog = false;
        });
    }

  }
};

</script>
